import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: "/public/home_page/img/google.png",
  alt: "Google"
}, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: "/public/home_page/img/twitter.png",
  alt: "Facebook"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: "/public/home_page/img/github.png",
  alt: "Facebook"
}, null, -1)

import { onMounted } from 'vue';
import { OAuthResult } from '../../../../server/dto/OAuthResult';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebaseui-ja/dist/firebaseui.css';
import { MessageDialog } from '../../../../framework/frontend/MessageDialog';
import { AuthService } from '../../../biz/remote/AuthService';
import router from '../../../router';
import { SessionUser } from '../../../utils/SessionUser';
import { getFirebaseAuthUi } from '../../../utils/firebaseAuthUi';
import firebaseui from 'firebaseui';
import {
  getAuth,
  signInWithPopup,
  GoogleAuthProvider,
  TwitterAuthProvider,
  GithubAuthProvider,
} from 'firebase/auth';

// const uiConfig: any = {
//   callbacks: {
//     signInSuccessWithAuthResult: (authResult: OAuthResult, redirectUrl: string) => {
//       const service = new AuthService();
//       service
//         .oAuthLogin(authResult.user.email, authResult)
//         .then((response) => {
//           if (response.hasError) MessageDialog.alert(`${response.errorDescription}`);

//           const user = response.data;
//           SessionUser.saveAuthUserInSession(user);

//           // console.log('SessionUser.isAuthorized', SessionUser.isAuthorized);
//           router.push({ name: "ListPage" });
//         })
//         .catch((e) => {
//           MessageDialog.alert(
//             `サインイン時にエラーが発生しました。操作ミスではなくシステムトラブルやバグの可能性があります。${e}`,
//             true
//           );
//         });
//       return false;
//     },
//     signInFailure: (error: firebaseui.auth.AuthUIError): Promise<void> | void => {
//       console.error("sign in error ", error);
//     },
//   },
//   signInFlow: "popup",
//   signInSuccessUrl: `${location.origin}/list`,
//   signInOptions: [
//     firebase.auth.GoogleAuthProvider.PROVIDER_ID,
//     firebase.auth.TwitterAuthProvider.PROVIDER_ID,
//     firebase.auth.GithubAuthProvider.PROVIDER_ID,
//   ],
//   // Terms of service url.
//   tosUrl: "/public/kiyaku.html",
//   // Privacy policy url.
//   privacyPolicyUrl: "/public/pp.html",
// };


export default /*#__PURE__*/_defineComponent({
  __name: 'OAuthLoginSection',
  setup(__props) {

onMounted(() => {
  sessionStorage.clear();
  const ui = getFirebaseAuthUi();
  // ui.start("#firebaseui-auth-container", uiConfig);
});

/**
 * Google / Twitter認証
 */
const authByOAuth = async (provider, auth) => {
  try {
    const result = await signInWithPopup(auth, provider);
    const user = result.user;
    console.log('user', user);

    const service = new AuthService();
    const response = await service.oAuthLoginByUser(user.email, user);

    if (response.hasError) MessageDialog.error(`${response.errorDescription}`);

    const authed_user = response.data;
    SessionUser.saveAuthUserInSession(authed_user);

    console.log('SessionUser.isAuthorized', SessionUser.isAuthorized);
    router.push({ name: 'ListPage' });
  } catch (e: any) {
    const error = e as any;
    MessageDialog.alert(
      `サインイン時にエラーが発生しました。操作ミスではなくシステムトラブルやバグの可能性があります。エラーコード：${error.code} メッセージ：${error.message} `,
      true
    );
  }
};

/**
 * Github認証
 */
const authByGithubAuth = async (provider, auth) => {
  try {
    const result = await signInWithPopup(auth, provider);
    const user = result.user;

    const service = new AuthService();

    // TODO: Github違いはここだけなので、まとめられそう
    const response = await service.oAuthLoginByUser(
      user.providerData[0].email,
      user.providerData[0] as any
    );

    if (response.hasError) MessageDialog.error(`${response.errorDescription}`);
    const authed_user = response.data;
    SessionUser.saveAuthUserInSession(authed_user);
    router.push({ name: 'ListPage' });
  } catch (e: any) {
    const error = e as any;
    MessageDialog.alert(
      `サインイン時にエラーが発生しました。操作ミスではなくシステムトラブルやバグの可能性があります。エラーコード：${error.code} メッセージ：${error.message} `,
      true
    );
  }
};
/**
 * Google Account でログイン
 * @returns
 */
const googleAuth = async () => {
  const provider = new GoogleAuthProvider();
  const auth = getAuth();
  auth.languageCode = 'it';
  await authByOAuth(provider, auth);
};

const twitterAuth = async () => {
  const provider = new TwitterAuthProvider();
  const auth = getAuth();
  auth.languageCode = 'it';
  await authByOAuth(provider, auth);
};
const githubAuth = async () => {
  const provider = new GithubAuthProvider();
  const auth = getAuth();
  auth.languageCode = 'it';

  // GitHubはユーザの情報が異なるので別メソッド
  await authByGithubAuth(provider, auth);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("a", {
      class: "social-button google-button",
      href: "#",
      onClick: googleAuth
    }, [
      _hoisted_1,
      _createTextVNode(" Googleで新規登録 ")
    ]),
    _createElementVNode("a", {
      class: "social-button twitter-button",
      href: "#",
      onClick: twitterAuth
    }, [
      _hoisted_2,
      _createTextVNode(" Twitterで新規登録 ")
    ]),
    _createElementVNode("a", {
      class: "social-button github-button",
      href: "#",
      onClick: githubAuth
    }, [
      _hoisted_3,
      _createTextVNode(" GitHubで新規登録 ")
    ])
  ]))
}
}

})